
import { ElevenLabsAgent } from "@/types/admin";
import { TableCell, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Eye } from "lucide-react";
import { formatDistanceToNow } from "date-fns";

interface AgentTableRowProps {
  agent: ElevenLabsAgent;
  onViewAgent: (agent: ElevenLabsAgent) => void;
}

export const AgentTableRow = ({ agent, onViewAgent }: AgentTableRowProps) => {
  // Check if created_at is a valid date string before parsing
  const timeAgo = agent.created_at ? (() => {
    try {
      const createdDate = new Date(agent.created_at);
      // Check if date is valid
      if (!isNaN(createdDate.getTime())) {
        return formatDistanceToNow(createdDate, { addSuffix: true });
      }
      return "Unknown";
    } catch (error) {
      console.error("Error parsing date:", error);
      return "Unknown";
    }
  })() : "Unknown";
  
  return (
    <TableRow>
      <TableCell className="font-medium">{agent.name}</TableCell>
      <TableCell>{agent.description || "No description"}</TableCell>
      <TableCell className="font-mono text-xs">{agent.agent_id}</TableCell>
      <TableCell>
        <Badge variant="success">Active</Badge>
      </TableCell>
      <TableCell className="text-muted-foreground text-sm">{timeAgo}</TableCell>
      <TableCell className="text-right">
        <Button variant="ghost" size="sm" onClick={() => onViewAgent(agent)}>
          <Eye className="h-4 w-4 mr-1" />
          View
        </Button>
      </TableCell>
    </TableRow>
  );
};
